/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from "@/api";

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
export const namespaced = true;

function emptyContactSearchFacets() {
  return {
    agreementTypes: [],
    localities: [],
    instrumentStatuses: [],
    instrumentRoles: [],
    propertyStatuses: [],
    propertyRoles: [],
    serviceIds: [],
    serviceRoles: [],
  };
}

function emptyContactSearchCategoryStates() {
  return {
    agreementTypes: false,
    localities: false,
    instrumentStatuses: false,
    instrumentRoles: false,
    propertyStatuses: false,
    propertyRoles: false,
    serviceIds: false,
  };
}

function emptyInstrumentSearchFacets() {
  return {
    agreementTypes: [],
    instrumentTypes: [],
    instrumentTags: [],
    instrumentStatuses: [],
    localities: [],
    staffLeads: [],
    grantPrograms: [],
    hasEventType: [],
    doesNotHaveEventType: [],
    eventDateBefore: [],
    eventDateAfter: [],
    contacts: [],
    notContacts: [],
    roles: [],
  };
}

function emptyInstrumentSearchCategoryStates() {
  return {
    agreementTypes: false,
    instrumentTypes: false,
    instrumentStatuses: false,
    localities: false,
    staffLeads: false,
    grantPrograms: false,
    contacts: false,
    events: false,
  };
}

function emptyProjectSearchFacets() {
  return {
    agreementTypes: [],
    projectIds: [],
    projectStatuses: [],
    localities: [],
    partnershipGrants: [],
    minimumAcres: [],
    maximumAcres: [],
    executedDateBefore: [],
    executedDateAfter: [],
  };
}
function emptyProjectSearchCategoryStates() {
  return {
    agreementTypes: false,
    projectIds: false,
    projectStatuses: false,
    localities: false,
    partnershipGrants: false,
    acres: false,
    executedDates: false,
  };
}

function emptyPropertySearchFacets() {
  return {
    agreementTypes: [],
    propertyIds: [],
    propertyStatuses: [],
    localities: [],
    minimumAcres: [],
    maximumAcres: [],
    exceedsAllowedDwellings: [],
    doesNotExceedAllowedDwellings: [],
    exceedsAllowedFinishedArea: [],
    doesNotExceedAllowedFinishedArea: [],
    exceedsAllowedImperviousSurface: [],
    doesNotExceedAllowedImperviousSurface: [],
  };
}
function emptyPropertySearchCategoryStates() {
  return {
    agreementTypes: false,
    propertyIds: false,
    propertyStatuses: false,
    localities: false,
    acres: false,
    rights: false,
  };
}

function emptyServiceSearchFacets() {
  return {
    serviceCategories: [],
    agreementTypes: [],
    serviceTypes: [],
    staffLeads: [],
    serviceStatuses: [],
    localities: [],
    reviews: [],
    reviewers: [],
    reviewAssigners: [],
    hasEventType: [],
    doesNotHaveEventType: [],
    eventDateBefore: [],
    eventDateAfter: [],
    fees: [],
    serviceProducts: [],
    previousServices: [],
  };
}

function emptyServiceSearchCategoryStates() {
  return {
    serviceCategories: false,
    serviceTypes: false,
    staffLeads: false,
    serviceStatuses: false,
    localities: false,
    reviews: false,
    reviewers: false,
    reviewAssigners: false,
    fees: false,
    serviceProducts: false,
    previousServices: false,
  };
}

async function getContact(crmId) {
  const response = await api
    .get(`/contact/get/${crmId}`)
    .then((resp) => resp.data)
    .catch(() => null);
  return response;
}

const searchFacetConfig = {
  Contact: {
    emptySearchFacets: emptyContactSearchFacets,
    emptySearchCategoryStates: emptyContactSearchCategoryStates,
  },
  Instrument: {
    emptySearchFacets: emptyInstrumentSearchFacets,
    emptySearchCategoryStates: emptyInstrumentSearchCategoryStates,
  },
  Project: {
    emptySearchFacets: emptyProjectSearchFacets,
    emptySearchCategoryStates: emptyProjectSearchCategoryStates,
  },
  Property: {
    emptySearchFacets: emptyPropertySearchFacets,
    emptySearchCategoryStates: emptyPropertySearchCategoryStates,
  },
  Service: {
    emptySearchFacets: emptyServiceSearchFacets,
    emptySearchCategoryStates: emptyServiceSearchCategoryStates,
  },
};

export const state = {
  searchEntityType: "Instrument",
  selectedSearchFacets: searchFacetConfig.Instrument.emptySearchFacets(),
  initialSearchCategoryStates: searchFacetConfig.Instrument.emptySearchCategoryStates(),
  searchResults: [],
  searchResultsLoading: false,
  facetChangeApplied: true,
  lastAppliedSearchHadNoFacets: true,
};

function convertContactRelatedArrays(fieldName, values) {
  if (fieldName === "contacts" || fieldName === "notContacts") {
    return values.map((x) => x.crmId);
  }
  return values;
}

export const actions = {
  async changeAdvancedSearchEntityType({ commit }, entityType) {
    commit("CHANGE_ADVANCED_SEARCH_ENTITY_TYPE", entityType);
  },
  async search({ commit }) {
    const searchFacetAttributes = Object.entries(state.selectedSearchFacets);
    // clear out results if we have not selected any facets
    if (searchFacetAttributes.flatMap((x) => x[1]).length === 0) {
      commit("SET_SEARCH_RESULTS", []);
      commit("SET_FACET_CHANGE_APPLIED", true);
    } else {
      // factor in search facets when performing the lookup
      const queryParamString = Object.entries(state.selectedSearchFacets).reduce(
        (queryString, set) => {
          const values = convertContactRelatedArrays(set[0], set[1]);
          if (!queryString && values.length > 0) {
            return `?${set[0]}=${values.join(`&${set[0]}=`)}`;
          }
          if (values.length > 0) {
            return `${queryString.toString()}&${set[0]}=${values.join(`&${set[0]}=`)}`;
          }
          return queryString;
        },
        ""
      );
      commit("SET_SEARCH_RESULTS_LOADING", true);
      await api
        .get(`/${state.searchEntityType}/search${queryParamString}`)
        .then((response) => {
          if (typeof response.data === "string") {
            commit("SET_SEARCH_RESULTS", JSON.parse(response.data));
          } else {
            commit("SET_SEARCH_RESULTS", response.data);
          }
          commit("SET_FACET_CHANGE_APPLIED", true);
        })
        .finally(() => {
          commit("SET_SEARCH_RESULTS_LOADING", false);
        });
    }
  },
  async clearSearchFacets({ commit }) {
    commit("CLEAR_SEARCH_FACETS");
    commit("SET_SEARCH_RESULTS", []);
    commit("SET_FACET_CHANGE_APPLIED", true);
    commit("SET_LAST_APPLIED_SEARCH_HAD_NO_FACETS", true);
  },
  async setLastAppliedSearchHadNoFacets({ commit }, value) {
    commit("SET_LAST_APPLIED_SEARCH_HAD_NO_FACETS", value);
  },
  async setSearchCategoryState({ commit }, type) {
    commit("SET_SEARCH_CATEGORY_STATE", type);
  },
  async updateSearchFacet({ commit }, { type, values }) {
    // for contacts, if we just have ids, we need to lookup the objects
    // all others just go straight into the facet
    if (
      (type === "contacts" || type === "notContacts") &&
      values.length > 0 &&
      Number.isInteger(parseInt(values[0], 10))
    ) {
      const newValues = await Promise.all(values.map((val) => getContact(val)));
      commit("SET_SEARCH_FACET", { type, values: newValues });
    } else {
      commit("SET_SEARCH_FACET", { type, values });
    }
    commit("SET_FACET_CHANGE_APPLIED", false);
  },
};

export const mutations = {
  CHANGE_ADVANCED_SEARCH_ENTITY_TYPE(state, value) {
    state.searchEntityType = value;
    state.selectedSearchFacets = searchFacetConfig[value].emptySearchFacets();
    state.searchResults = [];
  },
  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results;
  },
  SET_SEARCH_RESULTS_LOADING(state, loading) {
    state.searchResultsLoading = loading;
  },
  CLEAR_SEARCH_FACETS(state) {
    state.selectedSearchFacets = searchFacetConfig[state.searchEntityType].emptySearchFacets();
  },
  SET_SEARCH_FACET(state, changedFacet) {
    if (changedFacet.values) {
      if (typeof changedFacet.values === "string" || changedFacet.values instanceof String) {
        state.selectedSearchFacets[changedFacet.type] = [changedFacet.values];
      } else {
        state.selectedSearchFacets[changedFacet.type] = changedFacet.values;
      }
    } else {
      state.selectedSearchFacets[changedFacet.type] = [];
    }
  },
  SET_SEARCH_CATEGORY_STATE(state, type) {
    state.initialSearchCategoryStates[type] = true;
  },
  SET_FACET_CHANGE_APPLIED(state, changeApplied) {
    state.facetChangeApplied = changeApplied;
  },
  SET_LAST_APPLIED_SEARCH_HAD_NO_FACETS(state, newValue) {
    state.lastAppliedSearchHadNoFacets = newValue;
  },
};
